<app-dialog-header [title]="title" (onClick)="dialogRef.close(false)"></app-dialog-header>

<div class="p-24" fxLayout="column" fxLayoutAlign="start">
    <form class="move-members-form" [formGroup]="formGroup">
        <mat-form-field>
            <mat-label>{{ 'ENGAGE.EXPERIENCE.DIALOGS.MOVE_USER.SINGULAR' | translate }}</mat-label>
            <mat-select formControlName="experienceId">
                <mat-optgroup *ngFor="let experience of experiences; let j = index">
                    <mat-option [class.selected]="experience.open" [value]="experience.id">
                        {{ experience.name }}
                    </mat-option>
                </mat-optgroup>
            </mat-select>
        </mat-form-field>
    </form>
</div>
<div class="pt-24 action-buttons" fxLayout="row" fxLayoutAlign="end center">
    <app-white-button class="mr-8" [label]="'GENERAL.BUTTON.CANCEL'" (onClick)="dialogRef.close(false)"></app-white-button>

    <app-flat-button [label]="'GENERAL.BUTTON.SAVE'" (onClick)="onMoveMember()" [disabled]="parent && !parent.value"></app-flat-button>
</div>
